import './EndGamePage.scss'
import {useEffect} from "react";
import fanfara from "../../sounds/fanfara.mp3";
import medalSnd from "../../sounds/medal.mp3";
import {t} from "i18next";

export const PROGRESS_BY_DEADLINE = {
  3: 7,
  5: 10,
  7: 14,
}

const EndGamePage = (props) => {
  const {
    onChangeView,
    currentProgress,
    currentDeadline,
    soundsFX,
    soundsRef,
  } = props

  const medal = currentProgress >= PROGRESS_BY_DEADLINE[currentDeadline] ? "gold" : currentProgress === PROGRESS_BY_DEADLINE[currentDeadline] - 1 ? "silver" : "bronze"

  useEffect(()=>{
    soundsFX.onPlay(fanfara, false,false, soundsRef)
  }, [])

  const onHoverMedal = () => {
    soundsFX.onPlay(medalSnd, 'medal', true, soundsRef)
  }

  const onOutMedal = () => {
    soundsFX.onStopAll("medal")
  }

  return <div className="EndGamePage">
    <div className="NewGamePage-body">
      <div className="header"> {t('endgame-nw')}</div>
      <div className="multiline">
        <div>{t('endgame-and')} </div>
        <div>{t(`medals.${medal}`)} {t('endgame-medal')} </div>
        <div onMouseOver={()=>onHoverMedal()} onMouseLeave={()=>onOutMedal()} className={"medal " + medal}></div>
      </div>
      <button className="back-button" onClick={()=>onChangeView("MenuPage")}> {t('back')} </button>
      <button className="back-button next-button" onClick={()=>onChangeView("CreditsPage")}> {t('endgame-auth')} </button>
    </div>
  </div>
}

export default EndGamePage